import { render, staticRenderFns } from "./RiwayatPengisianHemodialisis.vue?vue&type=template&id=57c57011&scoped=true&"
import script from "./RiwayatPengisianHemodialisis.vue?vue&type=script&lang=ts&"
export * from "./RiwayatPengisianHemodialisis.vue?vue&type=script&lang=ts&"
import style0 from "./RiwayatPengisianHemodialisis.vue?vue&type=style&index=0&id=57c57011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c57011",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VSpacer})
